
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
  import delClass from './delClass.vue'
  import creatSecond from './creatSecond.vue'
  import {
    productproductFirstClassList,
    productproductClassSave
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      'slz-dialog': Dialog,
      delClass,
      creatSecond
    }
  })
  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0
    private rowmsg:any = {}
    private editShow = false
    private delShow = false
    private creatShow = false




    private mounted () {
      this.gettablelist()
    }



    private lookNext(row){
      this.$router.push({
        path:'secondClass',
        query:{
          Id:row.Id,
          Name:encodeURI(row.FirstClassName),
        }
      })
    }
    private creatNext(row){
      this.rowmsg = {
        Id:0,
        ClassName:'',
        Level:2,
        FirstClassName:row.FirstClassName,
        ParentId:row.Id
      }
      this.creatShow = true
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async confirmEdit(){
      if(!this.rowmsg.ClassName){
        this.$message.error('请输入类目名称')
        return 
      }
      try{
        let res = await productproductClassSave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('已创建')
          this.editShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private editFirstOrder(row){
      this.rowmsg = {
        Id:row.Id||0,
        ClassName:row.FirstClassName||'',
        Level:1,
      }
      this.editShow = true
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await productproductFirstClassList({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
